module.exports = __webpack_public_path__ + "img/tankoil.e84b90a6.png";